const state = {
    bid: null,
    pid: null,
    alphabet: null,
    keyword: null,
}

const mutations = {
    setBrand(state, p){
        return state.bid = p
    },
    setProd(state, p){
        return state.pid = p
    },
    setABC(state, p){
        return state.alphabet = p
    },
    setKeyword(state, p){
        return state.keyword = p
    }
}

export default {
    namespaced: true,
    state,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/product.js